module.exports = __webpack_public_path__ + "static/media/DSC.d8725920.png";